import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import logo from "../../Assets/0xfix.png";

function Home() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <div className="badge-container">
                <span className="hero-badge">
                  <span className="status-dot"></span>
                  Online Status
                </span>
              </div>

              <h1 style={{ paddingBottom: 15 }} className="heading font1 purple">
                <span className="gradient-text">0xfix</span>{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  <img src={logo} className="img-fluid logo-size floating-logo" alt="brand" />
                </span>
              </h1>

              <h1 className="heading-name">
                Node
                <strong className="main-name"> Runner</strong>
              </h1>

              <div style={{ padding: "30px 50px", textAlign: "left" }}>
                <Type />
              </div>

              <div className="hero-features">
                <div className="feature-card">
                  <div className="feature-icon">🔐</div>
                  <div>
                    <h4>Security</h4>
                    <p>99.9% uptime</p>
                  </div>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">⚡</div>
                  <div>
                    <h4>Speed</h4>
                    <p>12ms latency</p>
                  </div>
                </div>
                <div className="feature-card">
                  <div className="feature-icon">🌍</div>
                  <div>
                    <h4>Trusted</h4>
                    <p>Validator</p>
                  </div>
                </div>
              </div>

              <div className="cta-buttons">
                <Link to="/Staking">
                  <Button className="btn-staking">
                    Start Staking
                    <span className="btn-arrow">→</span>
                  </Button>
                </Link>
                <Button className="btn-docs">
                  Documentation
                </Button>
              </div>

              <div className="stats-bar">
                <div className="stat-item">
                  <span className="stat-icon">◎</span>
                  <span className="stat-value">Solana</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-icon">⟐</span>
                  <span className="stat-value">Ethereum</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-icon">⚛</span>
                  <span className="stat-value">Cosmos</span>
                </div>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }} className="hero-visual-col">
              <div className="visual-container" style={{
                transform: `translate(${mousePos.x * -0.5}px, ${mousePos.y * -0.5}px)`
              }}>
                <div className="floating-card card-1">
                  <span className="card-icon">◎</span>
                  <div className="card-info">
                    <span className="card-title">Solana</span>
                    <span className="card-value">Active</span>
                  </div>
                </div>
                <div className="floating-card card-2">
                  <span className="card-icon">⟐</span>
                  <div className="card-info">
                    <span className="card-title">Ethereum</span>
                    <span className="card-value">Active</span>
                  </div>
                </div>
                <div className="floating-card card-3">
                  <span className="card-icon">⚛</span>
                  <div className="card-info">
                    <span className="card-title">Cosmos</span>
                    <span className="card-value">Active</span>
                  </div>
                </div>

                <div className="center-logo">
                  <img src={logo} alt="0xFix" className="main-logo-img" />
                  <div className="logo-ring ring-1"></div>
                  <div className="logo-ring ring-2"></div>
                  <div className="logo-ring ring-3"></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
